import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
interface AccordionItemProps {
  title: string;
  children: React.ReactNode;
}
export function AccordionItem({
  title,
  children
}: AccordionItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-slate-200 last:border-0" data-id="element-1">
      <button onClick={() => setIsOpen(!isOpen)} className="flex w-full items-center justify-between py-4 text-left font-bold text-slate-800 hover:text-blue-600 transition-colors" data-id="element-2">
        <span className="text-lg" data-id="element-3">{title}</span>
        <ChevronDown className={`h-5 w-5 text-slate-400 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-4" />
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100 mb-4' : 'max-h-0 opacity-0'}`} data-id="element-5">
        <div className="text-slate-600 leading-relaxed pr-8" data-id="element-6">{children}</div>
      </div>
    </div>;
}